const fetchTitleHeader = new Promise((resolve) => {
  resolve({
    Bus: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    DownloadAllVoucher: {
      titleLink: '',
      titleName: ''
    },
    Error: {
      titleLink: '',
      titleName: 'Appologies'
    },
    Flight: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    FlightNextDay: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    FlyToDay: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    HotelBook: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    HotelList: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Message: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    MessageDetail: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    MessagesList: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    MyFlightUpdates: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    NpsPage: {
      titleLink: 'ExpireLink',
      titleName: 'Your opinion is important to us'
    },
    OverbookedPassenger: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    PassengerDetail: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    PaxContactConfirm: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    RebookCanx: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    RebookDly: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Refreshment: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    RentalCar: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    SelectManualService: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    SelectRoom: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    SelectService: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    ServiceAcceptance: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    ServiceOptionRefund: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    ServiceOptionRouting: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    ServiceRefreshment: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Taxi: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    TaxiCreditcard: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    TaxiPhotoPay: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Train: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    VirtualCreditCardDetail: {
      titleLink: 'Home',
      titleName: 'VIRTUAL CREDITCARDS'
    },
    VirtualHelpdesk: {
      titleLink: '',
      titleName: 'Virtual support desk'
    },
    WaitRebook: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Home: {
      titleLink: '',
      titleName: ''
    },
    NoHotelsAvailable: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    HotelTransport: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    CancelHotelRoom: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Disclaimer: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Privacy: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Impressum: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    Welcome: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    ShareUpdate: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    IframePopup: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    MyDocuments: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    MyDocumentsHome: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    PersonalDetails: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    CovidPortal: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    ShareTaxi: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    OptionTaxi: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    UpdatePhoneNumber: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    PhotoPay: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    PhotoPayMealPlan: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    KarhooTaxi: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    ExpireLink: {
      titleLink: 'ExpireLink',
      titleName: 'Expire Link'
    },
    MonetaryCompensation: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    CashPickUp: {
      titleLink: 'Home',
      titleName: 'Home'
    },
    TaxiService: {
      titleLink: 'Home',
      titleName: 'Home'
    }
  })
})

export { fetchTitleHeader }
